title: Make an Offer
description: |
  <p>Make an Offer allows you to list unexpected availability with specific date ranges and receive direct offers from qualified charter clients.</p>
  <p>Set your base charter rate and the discount percentage you’re willing to accept, then choose your preferred operating parameters using <strong>Flexible</strong>, or <strong>Fixed</strong> location options.</p>
  <p>Clients submit binding offers with a 5% deposit authorisation. If you accept an offer, Charter Index captures and retains the 5% as a referral fee. If you reject the offer or don’t respond within 7 days, the authorisation is automatically released. You maintain full control over which offers to accept.</p>
new: New Offer
none: You have not created any offers.
location:
  title: Departure & Return Locations
  mode:
    flexible:
      title: Flexible
      description: Allow consumers to search for any departure location in the specified sub-areas.
    fixed:
      title: Fixed
      description: Select one or more ports which the charter may depart from and return to.
      pickupLabel: Pickup Port(s)
      dropOffLabel: Drop Off Port(s)
labels:
  basePrice: Base Price
  maxDiscount: Maximum Discount %
  dates: Availability Window
  minDays: Minimum Charter Duration (days)
minDaysDescription: First and last days are half days
termsAndConditions:
  title: Make an Offer Terms & Conditions
faqs:
  title: Make an Offer FAQs

wizard:
  title: Make an Offer
  getStarted: Get Started
  yachtNotFound: "No yacht was found with the specified ID: \"{{ yachtId }}\""
  yachtForbidden: You do not have permission to create offers for that yacht.
  selectYacht:
    title: Which yacht is on offer?
  dates:
    title: When is the offer available?
    type:
      flexible: Your availability range is <strong>flexible</strong>.
      fixed: Your availability range is <strong>fixed</strong>.
    description:
      title: How do availability windows and minimum durations work?
      body: |
        <p>
          The availability window and minimum duration settings allow you to control both when and for how long clients can make offers.
        </p>
        <p>
          <strong>Availability window</strong> This is the overall period during which offers can be made - for example, a 30-day window covering the month of July.
        </p>
        <p>
          <strong>Minimum charter duration</strong> This is the shortest charter period you are willing to accept - for example, 7 days. If your minimum is shorter than your window, clients can position their preferred dates anywhere within it. If your window and minimum are the same length, the dates are effectively fixed and clients can only offer on that specific period.
        </p>
  locationMode:
    title: Where is the offer located?
    flexible:
      title: Flexible Itinerary Configuration
      body: The Flexible configuration requires you to first select a region - such as the Western Mediterranean or Caribbean - and then choose which sub-areas within that region you are willing to operate in, for example the French Riviera or Balearics. Clients then propose their own pickup and drop-off locations within your selected sub-areas.
    fixed:
      title: Fixed Itinerary Configuration
      body: The Fixed configuration allows you to define a shortlist of approved departure and return ports, or narrow it down to a single departure and return location for a completely predetermined routing. Clients can only submit offers using your pre-approved options, giving you precise control over positioning, port costs, and crew scheduling.
  location:
    title: Where is the offer located?
    selectArea: Select one or more regions.
    selectSubArea: Select one or more operating areas.
    fixed:
      description: Select one or more ports for departure & return.
      departure: Departure Port(s)
      return: Return Port(s)
      noOptions: No ports found in your selected operating area(s).
  rate:
    title: How much is the offer?
    description: Select a base rate.
  price:
    title: How much is the offer?
    acceptingOffers: "Accepting Offers:"
    plusTaxAndApa: "+ Tax & APA"
  review:
    title: Review & Publish Offer
    dateModes:
      flexible: "<strong>Flexible</strong> availability range:"
      fixed: "<strong>Fixed</strong> availability range:"
    maxDiscount: "Maximum Discount:"
    publish: Publish Offer
  createdNotification: Your offer has been published
  updatedNotification: Your offer has been updated
